module.exports = __webpack_public_path__ + "img/Tanzania.90b4f1f5.svg";